var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6166 0H4.38239C1.02977 0 -1.0952 3.48244 0.591499 6.29769L11.845 25.0802C12.5793 26.3066 14.4196 26.3066 15.154 25.0802L26.4098 6.29769C28.0942 3.48694 25.9692 0 22.6189 0H22.6166ZM11.8358 19.4476L9.385 14.8802L3.47142 4.69563C3.08131 4.04377 3.56316 3.20844 4.3801 3.20844H11.8335V19.4498L11.8358 19.4476ZM23.523 4.69342L17.6117 14.8824L15.1609 19.4476V3.20623H22.6143C23.4312 3.20623 23.9131 4.04156 23.523 4.69342Z",
    fill: "#99A8B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/ton.7d26242a36acb8724015b9233bec9768.svg";
export { ForwardRef as ReactComponent };